import { render, staticRenderFns } from "./BotaoTextoBase.vue?vue&type=template&id=57157035&scoped=true"
import script from "./BotaoTextoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoTextoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BotaoTextoBase.vue?vue&type=style&index=0&id=57157035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57157035",
  null
  
)

export default component.exports